<!-- Liste des lieux récents -->
<div class="pt-2">
    <list-view [liste]="listeLieuxRecents"></list-view>
</div>